import React, {Fragment} from "react";
import {MontageType} from "../../../Model";
import ImageRadioPicker from "../../../components/ImageRadioPicker";
import PropTypes from "prop-types";
import imageMuur from '../../../images/situation/montage/muurmontage.jpg';
import imageKozijn from '../../../images/situation/montage/kozijnmontage.jpg';

export default function MontageWindow(props) {
    return <Fragment>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={MontageType.MUUR}
                          image={imageMuur}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={MontageType.KOZIJN}
                          image={imageKozijn}/>
    </Fragment>
}

MontageWindow.propTypes = {
    currentValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
}